import { capitalCase } from '@opallabs/lambda'

export const humanizeSystemName = (name: string | undefined): string =>
  name ? capitalCase(name.replace(/_/g, ' ')) : ''
